import React from 'react';

import DjangoLogo from './DjangoLogo';
import RubyLogo from './RubyLogo';
import PythonLogo from './PythonLogo';
import JSLogo from './JSLogo';
import PHPLogo from './PHPLogo';
import D3Logo from './D3Logo';

import './projectCard.scss';

const NEW_TAB_ATTRS = {
    target: '_blank',
    rel: 'noopener noreferrer',
};

const technologyMap = {
    python: {
        logoComponent: PythonLogo,
        display: 'Python',
    },
    js: {
        logoComponent: JSLogo,
        display: 'JavaScript',
    },
    ruby: {
        logoComponent: RubyLogo,
        display: 'Ruby',
    },
    d3: {
        logoComponent: D3Logo,
        display: 'd3.js',
    },
    php: {
        logoComponent: PHPLogo,
        display: 'PHP',
    },
    django: {
        logoComponent: DjangoLogo,
        display: 'Django',
    },
};

const getLogo = (technology) => {
    if (!technology) {
        return null;
    }

    const LogoComponent = technologyMap[technology].logoComponent;

    return (
        <div className="open-source__project-logo">
            <LogoComponent />
        </div>
    );
};

const getThumbnail = (thumbnail) => {
    return (
        <div className="open-source__project-thumbnail-container">
            <img
                className="open-source__project-thumbnail"
                alt="Book image"
                src={thumbnail}
            />
        </div>
    );
};

const getSubheader = (subheader, link) => {
    if (!subheader) {
        return null;
    }

    if (!link) {
        return (
            <span className="open-source__project-subheader eds-text-bm eds-text-weight--heavy">
                {subheader}
            </span>
        );
    }

    return (
        <a
            className="open-source__project-subheader-link eds-link eds-text-weight--heavy"
            href={link}
            {...NEW_TAB_ATTRS}
        >
            {subheader}
        </a>
    );
};

const ProjectCard = ({
    name,
    subheader,
    subheaderLink,
    description,
    url,
    thumbnail,
    technology,
}) => {
    const projectImage = thumbnail
        ? getThumbnail(thumbnail)
        : getLogo(technology);

    return (
        <div className="eds-event-card--consumer">
            <div
                className={`open-source__project-card open-source__project-card--${technology} eds-card eds-card--neutral`}
                role="presentation"
            >
                <section
                    className="eds-media-card-content eds-media-card-content--grid eds-media-card-content--standard eds-media-card-content--fixed"
                    role="presentation"
                >
                    <aside className="eds-media-card-content__image-container">
                        <a
                            aria-label={`See more about ${name}`}
                            className="eds-media-card-content__action-link open-source__project-link"
                            href={url}
                            tabIndex="-1"
                        >
                            <div className="eds-media-card-content__image-wrapper eds-media-card-content__image-wrapper--sharp-corners">
                                <div className="eds-media-card-content__image-content eds-media-card-content__image-content--sharp-corners">
                                    <div className="eds-media-card-content__image-placeholder eds-align--center open-source__project-card-placeholder">
                                        {projectImage}
                                    </div>
                                </div>
                            </div>
                        </a>
                    </aside>
                    <main className="eds-media-card-content__content-container eds-media-card-content__content-container--consumer">
                        <div className="eds-media-card-content__content">
                            <div className="eds-media-card-content__content__principal">
                                <div className="eds-media-card-content__leading-content">
                                    <h3 className="open-source__project-name eds-l-mar-top-1">
                                        {name}
                                    </h3>
                                    {getSubheader(subheader, subheaderLink)}
                                </div>
                                <div className="eds-media-card-content__primary-content">
                                    <a
                                        aria-label={`See more about ${name}`}
                                        className="eds-media-card-content__action-link"
                                        href={url}
                                        tabIndex="0"
                                    >
                                        <div data-spec="event-card__formatted-name">
                                            <div className="eds-is-hidden-accessible">
                                                <h3 className="eds-media-card-content__title eds-text-color--grey-800 eds-text-bl eds-text-weight--heavy">
                                                    {name}
                                                </h3>
                                                <div
                                                    aria-hidden="true"
                                                    className="eds-event-card__formatted-name--is-clamped eds-event-card__formatted-name--is-clamped-three eds-text-weight--heavy"
                                                    data-spec="event-card__formatted-name--content"
                                                    role="presentation"
                                                >
                                                    <h3 className="eds-media-card-content__title eds-text-color--grey-800 eds-text-bl eds-text-weight--heavy">
                                                        {name}
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="eds-media-card-content__sub-content">
                                    <div className="open-source__project-description eds-media-card-content__sub eds-text-bm eds-text-color--grey-600 eds-l-mar-top-1">
                                        {description}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </section>
            </div>
        </div>
    );
};

export default ProjectCard;
